import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { TitleRegistrationService } from '../../titleregistration/services/titleregistration.service';
import { MVDNowViewService } from './mvdnow-view.service';
import { TitleViewBaseComponent } from './title-view-base.component';

@Component({
    selector: 'title-view',
    templateUrl: './title-view.html'
})
export class TitleViewComponent extends TitleViewBaseComponent implements OnDestroy {
    private viewServiceSubscription: Subscription;

    constructor(private router: Router,
        private activeRoute: ActivatedRoute,
        private trService: TitleRegistrationService,
        public viewService: MVDNowViewService) {
        super();
    }

    ngOnInit() {
        this.UseHelpContent('#CONTENT/AZ_MVD_Now/View_Title_Information_Full.htm%3FTocPath%3DAZ%2520MVD%2520Now%7C_____9');
        this.titleViewType = '(Full)';

        this.viewServiceSubscription = this.viewService.customerNumberSubject.subscribe(
            async customerNumber => {
                if (customerNumber) {
                    const vehicleId = this.viewService.selectedVehicleId;
                    this.trService.getVehicleTitleFull(vehicleId, customerNumber).pipe(
                        finalize(() => {
                            this.loaded = true;
                        }))
                        .subscribe(
                            (data) => {
                                this.setTitleInfo(data.result);
                            },
                            (error) => {
                                this.handleValidationResult(error);
                            });
                }
            }
        );
    }

    ngOnDestroy() {
        if (this.viewServiceSubscription) {
            this.viewServiceSubscription.unsubscribe();
            this.viewServiceSubscription = null;
        }
        super.ngOnDestroy();
    }
}
